module.exports = __webpack_public_path__ + "img/d3.b79f4d20.webp";